import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { CONFIG } from '../../config/app.config';

@Injectable({
  providedIn: 'root'
})

export class AppInfoService {
  private baseURL = CONFIG.apiURL;
  private authURL = CONFIG.authURL;
  //private baseURL = CONFIG.apiDevURL;
  bAllowUpdates: boolean;

  constructor(private httpClient: HttpClient) {
    this.bAllowUpdates = true;
    console.log('AppInfoService constructor');
  }

  public get title() {
    return 'Smart Template Scoring System';
  }

  public getToken(userName: string, password: string, clientID: string, clientSecret: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded'
      })
    };

    const headers =  {
      'Content-Type': 'application/x-www-form-urlencoded'
    };

    const params = new HttpParams()
      .set('grant_type', 'password')
      .set('username', encodeURIComponent(userName.trim()))
      .set('password', encodeURIComponent(password.trim()));

      return this.httpClient.post(this.authURL + 'token', params, httpOptions );
  }

  public refreshToken(token: string, refreshToken: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded',
        Authorization: token
      })
    };

    const params = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', refreshToken);

      return this.httpClient.post(this.authURL + 'token', params, httpOptions );

  }

  public logoff(token: string, refreshToken: string)
  {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: 'Bearer ' + token
      })
    };

    const postData = {
     refreshToken: refreshToken
    };

    const jsonStr = JSON.stringify(postData);

    console.log('http logoff post');
    return this.httpClient.post(this.authURL + 'usermgmt/logoff/', jsonStr, httpOptions);
  }


  public resetPassword(token: string, userName: string, oldPassword: string, newPassword: string)
  {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: 'Bearer ' + token
      })
    };

    const postData = {
     userName: userName,
     oldPassword: oldPassword,
     newPassword: newPassword
    };

    const jsonStr = JSON.stringify(postData);

    console.log('http reset password post');
    return this.httpClient.post(this.authURL + 'usermgmt/resetpassword/', jsonStr, httpOptions);
  }

  public getWorksheets(token: string, userName: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: 'Bearer ' + token
      })
    };

    const useURL = this.baseURL + 'worksheets/' + userName;
    console.log('getWorksheets: useURL: ' + useURL);

    return this.httpClient.get(useURL, httpOptions);
  }
  
  public getWorksheet(token: string, organ: string, year: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: 'Bearer ' + token
      })
    };

    return this.httpClient.get(this.baseURL + 'worksheet/' + organ + '/' + year, httpOptions);
  }

  public getTooltip(token: string, worksheet: any, controlID: string) { 
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: 'Bearer ' + token
      })
    };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.get(this.baseURL + 'worksheet/tooltip/' + worksheet.worksheetData.Organ + '/' + worksheet.worksheetData.Year + '/' + controlID, httpOptions);
  }

  public getStatus(token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: 'Bearer ' + token
      })
    };

    return this.httpClient.get(this.baseURL + 'worksheet/status', httpOptions);
  }
  
  public updateWorksheet(token, worksheet) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: 'Bearer ' + token
      })
    };
    console.log(worksheet);
    const postData = {
     worksheet: {
       IsFirstUpdate: worksheet.IsFirstUpdate,
       ForceReset: worksheet.ForceReset,
       Version: worksheet.worksheetData.Version,
       Organ: worksheet.worksheetData.Organ,
       Year: worksheet.worksheetData.Year,
       Language: worksheet.worksheetData.Language,
       ModifiedControlID: worksheet.ModifiedControlID,
       ControlDictionary: worksheet.controlsDict,
       Categories: worksheet.worksheetData.Categories
     }
    };

    const jsonStr = JSON.stringify(postData);

    console.log('http update post');
    return this.httpClient.post(this.baseURL + 'worksheet/worksheetupdate/', jsonStr, httpOptions);
  }

  
}
